import React from 'react';
import { colorFromName } from '../../utilities/accountIcons.js';

/**
 * An institution's logo, or a stand-in when there isn't one.
 *
 * Logos come from Monarch's account list, stored once per institution (Services\Accounts\Institution_Logos),
 * so an institution no connected budget banks with through Monarch has none — AFR LoanCare, for one.
 * Rather than leave a hole in the row, fall back to a monogram tinted with the institution's
 * primary_color where Plaid reported one, and to a colour derived from the name where it did not.
 *
 * `color` is the colour the budget chose for the institution, and wins over both. `name` is what the
 * budget calls it, which the monogram is made from when given.
 */
export default function InstitutionBadge({ institution, size = 24, color = null, name = null }) {
	const style = { width: size, height: size, lineHeight: `${size}px` };

	if(institution && institution.image_url) {
		return (
			<img
				className='institution_badge'
				style={style}
				src={institution.image_url}
				alt={institution.name || ''}
			/>
		);
	}

	name = name || (institution && institution.name) || '';
	const background = color || (institution && institution.primary_color) || colorFromName(name);

	return (
		<span
			className='institution_badge institution_badge_monogram'
			style={{ ...style, backgroundColor: background, fontSize: Math.round(size * 0.45) }}
			title={name}
		>
			{monogram(name)}
		</span>
	);
}

/** Up to two initials, so "American Eagle - Synchrony Bank" reads as AE rather than a wall of text. */
function monogram(name) {
	const words = name.replace(/[^A-Za-z0-9 ]/g, ' ').split(' ').filter(Boolean);
	if(!words.length) {
		return '?';
	}
	if(words.length === 1) {
		return words[0].slice(0, 2).toUpperCase();
	}
	return (words[0][0] + words[1][0]).toUpperCase();
}
